export default __webpack_public_path__ + "static/media/shutterstock_577635616.ebbef556.jpg";